import React, { useState } from 'react';
import { ArrowRightIcon, CheckIcon } from 'lucide-react';
import { services, stats, processSteps, processImage } from '../lib/data';
import { Eyebrow, Reveal } from '../components/ui/Reveal';
import { Button } from '../components/ui/Button';
export function Employers() {
  const [sent, setSent] = useState(false);
  const [form, setForm] = useState({
    name: '',
    company: '',
    email: '',
    role: '',
    message: ''
  });
  const update = (k: keyof typeof form, v: string) => setForm(f => ({
    ...f,
    [k]: v
  }));
  return <div data-id="element-331" data-mp="crlz8xr48181">
      <section className="mx-auto max-w-7xl px-6 pt-14 lg:px-10 lg:pt-20" data-id="element-332" data-mp="cqu6duowkhlg">
        <div className="max-w-3xl" data-id="element-333" data-mp="8no1aqdj0wgk">
          <Eyebrow data-id="element-334" data-mp="8qtqe5m5nyca">For employers &amp; boards</Eyebrow>
          <h1 className="mt-6 font-serif text-4xl leading-[1.1] text-ink sm:text-5xl lg:text-6xl" data-id="element-335" data-mp="3qfiqooguqes">
            A search partner as ambitious as you are.
          </h1>
          <p className="mt-6 max-w-xl text-lg leading-relaxed text-ink-600" data-id="element-336" data-mp="2ofv597gnjsym">
            We combine deep sector expertise, a truly global network and rigorous
            assessment to place the leaders who transform organisations.
          </p>
          <div className="mt-8 flex flex-col gap-4 sm:flex-row" data-id="element-337" data-mp="3jj8ek0ur0k87">
            <Button href="#engage" variant="primary" size="lg" data-id="element-338" data-mp="35l9z0s4oyhr4">
              Start a search <ArrowRightIcon className="h-4 w-4" data-id="element-339" data-mp="3ajtnp0ao67n6" />
            </Button>
            <Button to="/firm" variant="outline" size="lg" data-id="element-340" data-mp="3ai0h1l023nf6">
              Manage your firm
            </Button>
          </div>
        </div>

        <div className="mt-16 grid grid-cols-2 gap-px overflow-hidden rounded-2xl border border-ink/10 bg-ink/5 lg:grid-cols-4" data-id="element-341" data-mp="30ldy51raj6fs">
          {stats.map(s => <div key={s.label} className="bg-ivory-50 px-6 py-8 text-center" data-id="element-342" data-mp="2ms63f17wxutv">
              <p className="font-serif text-3xl text-ink lg:text-4xl" data-id="element-343" data-mp="2qwdu33xxlkuq">{s.value}</p>
              <p className="mt-2 text-xs uppercase tracking-widest2 text-ink-500" data-id="element-344" data-mp="2cx4g8ax772tx">
                {s.label}
              </p>
            </div>)}
        </div>
      </section>

      <section className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-345" data-mp="nf7j26o1vsid">
        <div className="grid gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-346" data-mp="io8xarkam27q">
          <Reveal data-id="element-347" data-mp="imxvuyebl6js">
            <div data-id="element-348" data-mp="imecdd90ua3n">
              <Eyebrow data-id="element-349" data-mp="emdz3vxns4y6">How we partner</Eyebrow>
              <h2 className="mt-6 font-serif text-3xl leading-tight text-ink sm:text-4xl" data-id="element-350" data-mp="en5k6ctmqka7">
                Rigour, discretion, and a genuine partnership.
              </h2>
              <p className="mt-4 text-lg leading-relaxed text-ink-600" data-id="element-351" data-mp="16e3cvgvzy4vo">
                Every mandate is led by a partner from first brief to successful
                onboarding — never delegated, never rushed.
              </p>
              <div className="mt-8 overflow-hidden rounded-2xl" data-id="element-352" data-mp="xbkdx7vc0cep">
                <img src={processImage} alt="Recruiter in partnership meeting" className="h-72 w-full object-cover" data-id="element-353" data-mp="setty9geowo0" />
              </div>
            </div>
          </Reveal>
          <div className="space-y-4" data-id="element-354" data-mp="3d2yhr6u07hnl">
            {services.map((service, i) => <Reveal key={service.title} delay={i * 0.08} data-id="element-355" data-mp="331w51nx0idsa" data-mpi={i}>
                <div className="rounded-2xl border border-ink/10 bg-ivory-50 p-6 transition-colors hover:border-gold/50" data-id="element-356" data-mp="37ywapxpy9eiv">
                  <h3 className="font-serif text-xl text-ink" data-id="element-357" data-mp="3cxqqeqsmemyr">{service.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-600" data-id="element-358" data-mp="3hph518ylbwvz">
                    {service.description}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </section>

      <section className="bg-ink text-ivory-200" data-id="element-359" data-mp="3qo2m0zoez3un">
        <div className="mx-auto max-w-7xl px-6 py-20 lg:px-10 lg:py-28" data-id="element-360" data-mp="3vogwsphegrwd">
          <Reveal data-id="element-361" data-mp="4ip5hmrvz97z">
            <Eyebrow className="text-gold" data-id="element-362" data-mp="4j8pra50e9p6">The process</Eyebrow>
            <h2 className="mt-6 max-w-2xl font-serif text-3xl leading-tight text-ivory-100 sm:text-4xl" data-id="element-363" data-mp="4gmfh2qqhg39">
              Four disciplined stages to an exceptional hire.
            </h2>
          </Reveal>
          <div className="mt-14 grid gap-8 sm:grid-cols-2 lg:grid-cols-4" data-id="element-364" data-mp="26bwwhtgv3f9p">
            {processSteps.map((step, i) => <Reveal key={step.number} delay={i * 0.1} data-id="element-365" data-mp="3rscq13p4qcv2" data-mpi={i}>
                <div data-id="element-366" data-mp="3rrtaftmyc0k7">
                  <span className="font-serif text-4xl text-gold" data-id="element-367" data-mp="3rufirvho2k3h">{step.number}</span>
                  <h3 className="mt-4 font-serif text-xl text-ivory-100" data-id="element-368" data-mp="9kdipiga8q0e">{step.title}</h3>
                  <p className="mt-2 text-sm leading-relaxed text-ink-400" data-id="element-369" data-mp="4o6a1hwi50er">
                    {step.description}
                  </p>
                </div>
              </Reveal>)}
          </div>
        </div>
      </section>

      <section id="engage" className="mx-auto max-w-3xl px-6 py-20 lg:py-28" data-id="element-370" data-mp="3msq485v8joan">
        <div className="rounded-3xl border border-ink/10 bg-ivory-50 p-8 shadow-soft sm:p-12" data-id="element-371" data-mp="3muui9gmum3on">
          {sent ? <div className="py-8 text-center" data-id="element-372" data-mp="2ucff47iu0k5m">
              <span className="mx-auto flex h-16 w-16 items-center justify-center rounded-full bg-gold/15 text-gold-dark" data-id="element-373" data-mp="2ub49011wz0bc">
                <CheckIcon className="h-8 w-8" data-id="element-374" data-mp="2pbj7pjz9ufvg" />
              </span>
              <h2 className="mt-6 font-serif text-2xl text-ink" data-id="element-375" data-mp="14us054ohmcp7">Thank you</h2>
              <p className="mx-auto mt-3 max-w-md text-sm leading-relaxed text-ink-600" data-id="element-376" data-mp="19mjnz7g9e4bn">
                A partner will be in touch within one working day to arrange a confidential
                conversation.
              </p>
            </div> : <>
              <div className="text-center" data-id="element-377" data-mp="1oju0mk4n1g8y">
                <Eyebrow data-id="element-378" data-mp="1ok2dic0rglk5">Begin a conversation</Eyebrow>
                <h2 className="mt-5 font-serif text-3xl text-ink" data-id="element-379" data-mp="1skw3rc1oecg7">Engage our team</h2>
                <p className="mt-3 text-sm leading-relaxed text-ink-600" data-id="element-380" data-mp="1eld477mxk9fi">
                  Tell us a little about your mandate. Everything you share is treated in
                  strict confidence.
                </p>
              </div>
              <form className="mt-8 space-y-4" onSubmit={e => {
            e.preventDefault();
            setSent(true);
          }} data-id="element-381" data-mp="356agppe1dsj">
                <div className="grid gap-4 sm:grid-cols-2" data-id="element-382" data-mp="3k7ak3bmbewjn">
                  <FormField label="Your name" value={form.name} onChange={v => update('name', v)} required data-id="element-383" data-mp="3g78sxwe7hlim" />
                  <FormField label="Company" value={form.company} onChange={v => update('company', v)} required data-id="element-384" data-mp="3bfqouzgvz4tf" />
                </div>
                <div className="grid gap-4 sm:grid-cols-2" data-id="element-385" data-mp="36gnvica9qn1a">
                  <FormField label="Work email" type="email" value={form.email} onChange={v => update('email', v)} required data-id="element-386" data-mp="31im4n56lpjf9" />
                  <FormField label="Role you’re hiring" value={form.role} onChange={v => update('role', v)} data-id="element-387" data-mp="2wi85ydqw3ltw" />
                </div>
                <label className="block" data-id="element-388" data-mp="2sjil603iv208">
                  <span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-ink-600" data-id="element-389" data-mp="2nj37f7fbvshq">
                    How can we help?
                  </span>
                  <textarea rows={4} value={form.message} onChange={e => update('message', e.target.value)} className="w-full resize-none rounded-xl border border-ink/15 bg-ivory-100 px-4 py-3 text-sm text-ink placeholder:text-ink-400 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold" placeholder="Briefly describe the leadership challenge…" data-id="element-390" data-mp="lqyj05x1fdbr" />
                </label>
                <Button variant="gold" size="lg" className="w-full" data-id="element-391" data-mp="ablhxto508k8">
                  Request a confidential call
                </Button>
              </form>
            </>}
        </div>
      </section>
    </div>;
}
function FormField({
  label,
  value,
  onChange,
  type = 'text',
  required
}: {
  label: string;
  value: string;
  onChange: (v: string) => void;
  type?: string;
  required?: boolean;
}) {
  return <label className="block" data-id="element-392" data-mp="1vnwluyqljehs">
      <span className="mb-1.5 block text-xs font-medium uppercase tracking-wide text-ink-600" data-id="element-393" data-mp="1voojef3r7map">
        {label}
      </span>
      <input type={type} required={required} value={value} onChange={e => onChange(e.target.value)} className="w-full rounded-xl border border-ink/15 bg-ivory-100 px-4 py-3 text-sm text-ink placeholder:text-ink-400 focus:border-gold focus:outline-none focus:ring-1 focus:ring-gold" data-id="element-394" data-mp="1zse60z0vbtt3" />
    </label>;
}